import { useDispatch } from "react-redux";
import Crypto from 'crypto-js'
import parse from 'html-react-parser';
import { AlertMsg, AlertTitle, SwAlert } from "src/Components/Alert/Sweetalert";
import { AxiosGetAsync } from "src/CommonFunction/TS_Axios";
import { i18n } from "src/i18n";
import { useLocation } from "react-router";
export const Process_System = {
    process_Success: "Success",
    process_Error: "Error",
    process_Failed: "Failed",
};

export const TooltipsMSG = {
    Add: "Add",
    Edit: "Edit",
    Delete: "Delete",
    View: "View",
    Search: "Search",
    Save: "Save",
    Approve: "Approve",
    Reject: "Reject",
    Cancel: "ยกเลิก",
    Logout: "Logout",
    ReviewContent: "Review Content",
    File: "File",
    DownloadTemplate: "Download Template",
    Download: "Download",
    Close: "Close",
    MasterData: "Master Data",
    DocRef: "Document reference",
    Check: "Check",
    Submit: "Submit",
    NewRegistration: "Registration",
    Withdraw: "Withdraw",
    SendToVendor: "Send To Vendor"
};
export const EncryptApi = async (sValue) => {
    let Result = "";
    Result = await AxiosGetAsync("Master/Encrypt", { sValue: sValue });
    return Result;
};
export const DecryptApi = async (sValue) => {
    let Result = "";
    Result = await AxiosGetAsync("Master/Decrypt", { sValue: sValue });
    return Result;
}

export const Extension = {
    Image: ["jpg", "jpeg", "png", "gif"],
    Video: ["mov", "wmv", "avi", "mp4"],
    PDF: ["pdf"],
    Document: ["doc", "docx", "xls", "xlsx", "txt"],
    Word: ["doc", "docx"],
    Excel: ["xls", "xlsx"],
    Powpoint: ["pptx", "pdf", "ppt"],
    txt: ["txt"],
    Email: ["msg"],
    Other: ["rar", "zip"],
    OBAFile:["jpg","jpeg","png","gif","docx","xlsx","pdf","rar","zip"],
    AllType: null,
  };


export const ResultAPI = (
    IsLoadData = false,
    response,
    MSG_Success,
    fnOnSuccess?,
    fnOther?
) => {
    let { nPermission } = response;
    let sStatus = response.Status;
    let sMsg = response.Message;
    const {
        // process_SessionExpire,
        // process_Duplicate,
        process_Success,
        process_Error,
        process_Failed,
    } = Process_System;
    if (sStatus === process_Success) {
        if (!nPermission) nPermission = 1;
        if (nPermission === 0) {
            NoPermission();
        } else {
            if (!IsLoadData) {
                if (!MSG_Success) MSG_Success = AlertMsg.SaveComplete;
                SwAlert.Success(AlertTitle.Success, MSG_Success, fnOnSuccess);
            } else {
                if (fnOnSuccess) fnOnSuccess();
            }
        }
    } else if (sStatus === process_Failed) {
        // let tempMsg = AlertMsg.Duplicate;
        // if (!sMsg) {
        //   sMsg = tempMsg;
        // }
        if (!IsLoadData) {
            SwAlert.Warning(AlertTitle.Warning, sMsg, () => {
                if (fnOther) fnOther();
            });
        } else {
            if (fnOnSuccess) fnOnSuccess();
        }
    } else if (sStatus === process_Error) {
        if (!IsLoadData) {
            SwAlert.Error(AlertTitle.Error, sMsg, () => {
                if (fnOther) fnOther();
            });
        } else {
            if (fnOnSuccess) fnOnSuccess();
        }
    } else {
        if (fnOnSuccess) fnOnSuccess();
    }
};

export const NoPermission = () => {
    SwAlert.Warning(undefined, i18n("common.NoPermission"), () => {
        // window.location.href = "/";
        // window.location.href = `${process.env.REACT_APP_API_URL}`;
        lnkToHomePage()
    });
};

export const IsNumberic = (sVal) => {
    sVal = (sVal + "").replace(/,/g, '');
    console.log("sVal", sVal, !isNaN(sVal) && sVal !== "")
    return (!isNaN(sVal) && sVal !== "");
}

export const ParseFloatToZero = (sVal) => {
    sVal = (sVal + "").replace(/,/g, '');
    return !isNaN(parseFloat(sVal)) ? parseFloat(sVal) : 0;
}

export const ParseFloatToNull = (sVal) => {
    sVal = (sVal + "").replace(/,/g, '');
    return !isNaN(parseFloat(sVal)) ? parseFloat(sVal) : null;
}

export const ParseNumberToNull = (sVal) => {
    sVal = (sVal + "").replace(/,/g, '');
    return !isNaN(Number(sVal)) ? Number(sVal) : null;
}

export const ParseNumberToZero = (sVal) => {
    sVal = (sVal + "").replace(/,/g, '');
    return !isNaN(Number(sVal)) ? Number(sVal) : 0;
}

const keyCrypto = "P4ssw0rd3ndCr7pt"
export const Encrypt = (dataEncrypt) => {
    let data = dataEncrypt.toString()
    let result = Crypto.AES.encrypt(data, keyCrypto).toString()
    result = result.replace(/\//g, "s14sh").replace(/\+/g, 'p1u5')

    return result
}
export const Decrypt = (dataDecrypt) => {
    if (dataDecrypt && dataDecrypt != null && dataDecrypt != "null") {
        dataDecrypt = dataDecrypt.replace(/s14sh/g, '/').replace(/p1u5/g, '+')
        let bytes = Crypto.AES.decrypt(dataDecrypt, keyCrypto)
        let result = bytes.toString(Crypto.enc.Utf8)
        return result
    } else {
        return "";
    }
}

export const ParseHtml = (val) => {
    if (val)
        return parse(val);
    else
        return val;
}
export const actionBlockUI = () => {
    return { type: "BLOCK_UI" };
};

export const actionUnBlockUI = () => {
    return { type: "UNBLOCK_UI" };
};

export const FnBlock_UI = () => {
    const Dispatch = useDispatch();
    const BlockUI = () => Dispatch(actionBlockUI());
    const UnBlockUI = () => Dispatch(actionUnBlockUI());
    return { BlockUI, UnBlockUI };
};


export const mobileCheck = (window) => {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

export const getOS = () => {
    var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = '';
    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }
    return os;
}

export const lnkToLogin = () => {
    let el = document.getElementById("lnkToLogin") as any
    el && el.click()
}
export const lnkToHomePage = () => {
    let el = document.getElementById("lnkToHomePage") as any
    el && el.click()
}
export const IsEmpty = (value) => {
    if (value === null || value === undefined || value === "")
        return true;
    else
        return false;
}

export const IsNullOrUndefined = (Value) => {
    let Result = true;
    if (Value) {
        Result = false;
    }
    return Result;
};
export const GetQueryString = (Value) => {
    const location = useLocation();
    const searchParams = location.search;
    let Result = "";
    if (Value) {
        Result = new URLSearchParams(searchParams).get(Value) as string;
        Result = (!IsNullOrUndefined(Result)) ? Result.replace(/\+/gi, '%2B') : "";//ดักกรณีเป็นค่าว่าง
    }
    return Result;
};